<div class="cnpj-validation">
    <div class="texts">
        <p class="title">{{ 'pages.partnerRegistration.validation.title' | i18n }}</p>
        <p class="subtitle">{{ 'pages.partnerRegistration.validation.subtitle' | i18n }}</p>
    </div>
    <umkt-card-wrapper
        class="cnpj-card_wrapper"
        [title]="'pages.partnerRegistration.validation.cardTitle' | i18n"
        [description]="'pages.partnerRegistration.validation.cardDescription' | i18n"
        [icon]="{name: 'pme', type: 'mondrian-icons'}"
        [variant]="'default'"
        >
            <div class="cnpj-validation-content">
                <form [formGroup]="form" class="cnpj-form">
                    <div class="input-group">
                        <input
                        type="text"
                        placeholder=" "
                        formControlName="cnpj"
                        class="input"
                        (input)="applyCnpjMask($event)"
                        />
                        <label for="cnpj" class="label-floating">{{ 'pages.partnerRegistration.validation.cnpjLabel' | i18n }}</label>
                        <span class="icon mdn-Icon-lupa"></span>
                    </div>
                    <div *ngIf="message && !(status === 'token_required' && isError)"
                            class="info-message"
                            [ngClass]="{ 'error': isError, 'success': !isError }">

                        <span [class]="isError ? 'mdn-Icon-error-circulo' : 'mdn-Icon-check-circulo'"></span>

                        <span>{{ message | i18n }}</span>
                    </div>

                    <div *ngIf="status === 'token_required'" class="input-group">
                        <input
                        type="text"
                        placeholder=" "
                        formControlName="token"
                        class="input"
                        />
                        <label for="token" class="label-floating">{{ 'pages.partnerRegistration.validation.tokenLabel' | i18n }}</label>
                
                    </div>
                    <div
                      *ngIf="status === 'token_required' && isError && message"
                      class="info-message error token-error"
                    >
                      <span class="mdn-Icon-error-circulo"></span>
                      <span>{{ message }}</span>
                    </div>

                    <div class="actions">
                        <button
                        type="button"
                        class="btn-primary"
                        (click)="onContinue()"
                        [disabled]="status === 'completed' || isLoading || isCnpjLockedByInvalid"
                        >
                            {{ 'pages.partnerRegistration.validation.buttonContinue' | i18n }}
                        </button>
                    </div>
                    </form>
            </div>
    </umkt-card-wrapper>
</div>